import fp from '@fingerprintjs/fingerprintjs';
import { readonly, reactive } from '@vue/composition-api';

export default () => {
  const props = reactive<{ value: string; resolved: boolean }>({
    value: '',
    resolved: false,
  });
  void (async () => {
    try {
      const fpPromise = await fp.load();
      const { visitorId } = await fpPromise.get();
      Object.assign(props, { value: visitorId, resolved: true });
    } catch (e) {
      // 何らかの問題でfingerprintが取得できない場合。
      Object.assign(props, { value: '', resolved: true });
    }
  })();
  return readonly(props);
};
